/**
 * Tag filters directive
 */

angular.module("common").directive("epiTagFiltersCreator", function ($parse) {
  return {
    restrict: "A",
    scope: {
      tags: "=tags",
      tagFilters: "=tagFilters",
      allowPrivate: "=?",
      fullWidth: "=?",
    },
    templateUrl: "/directives/epi-tag-filters-creator.html",
    link: function (scope, element, attrs) {
      if (!scope.allowPrivate) scope.allowPrivate = false;

      scope.tagFilterSortable = {
        appendTo: "body",
        placeholder: "placeholder",
        connectWith: ".tag-list",
        cancel: ".cancel",
      };

      if (!scope.tags) throw new ReferenceError("epi-tag-filters-creator: no tags provided!");

      if (!scope.tagFilters) {
        throw new ReferenceError("epi-tag-filters-creator: no tag filters object provided!");
      } else {
        var filterDefaults = {
          includeIfAny: 1,
          excludeIfAny: 1,
          exclude: [],
          include: [],
        };
        scope.tagFilters = _.merge(filterDefaults, scope.tagFilters);
      }

      scope.tagListSortable = {
        appendTo: "body",
        placeholder: "placeholder",
        connectWith: ".drop",
        zIndex: 5000,
        helper: function (event, element) {
          return $($(element).clone().css({ width: 75, height: 25 }));
        },
      };
    },
  };
});
